import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  permissions: string[];
  token: string | null;
  isAuthenticated: boolean;
  signedIn: boolean;
}

const initialState: AuthState = {
  permissions: JSON.parse(localStorage.getItem('permissionRoutes') || '[]'),
  token: localStorage.getItem('accessToken'),
  isAuthenticated: !!localStorage.getItem('accessToken'),
  signedIn: false
};

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      state.isAuthenticated = true;
    },
    setUserPermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload;
    },
    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      localStorage.clear();
      state.signedIn = false;
    },
    setSignedIn: (state, action: PayloadAction<boolean>) => {
      state.signedIn = action.payload;
    }
  }
});

export const { setAuthToken, logout, setUserPermissions, setSignedIn } =
  auth.actions;

export default auth.reducer;
